import React, { useEffect, useRef } from "react";
import { Grid, Typography, Container, Stack, Box } from "@mui/material";
import CardOne from "../../../components/Experience/ExperienceCardOne/CardOne";
import CardTwo from "../../../components/Experience/ExperienceCardTwo/CardTwo";
import "./animateline.css";

const Experience = () => {
  const svgRef = useRef(null);

  

  return (
    <Container sx={{ marginBottom: { lg: "140px" } }}>
      <Grid
        container
        style={{
          justifyContent: "center",
          alignItems: { xs: "center" },
          marginTop: "70px",
        }}
      >
        <Grid item>
          <Typography
            variant="h5"
            sx={{
              color: "#00adb5",
              fontWeight: 500,
              fontFamily: "Getboreg Trial Only",
            }}
          >
            MY JOURNEY
          </Typography>
        </Grid>
      </Grid>
      <Stack
        spacing={2}
        direction={{ xs: "column", md: "row" }}
        sx={{
          maxWidth: "1024px",
          width: "100%",
          alignItems: "center",
          gap: { md: "80px", xs: "40px" },
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: { md: "60px", xs: "20px" },
          position: "relative",
        }}
      >
        <div className="animated-line">
          <svg
            width="6"
            height="601"
            viewBox="0 0 6 601"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="svgPath"
              ref={svgRef}
              d="M0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3ZM2.49997 600C2.49997 600.276 2.72383 600.5 2.99997 600.5C3.27612 600.5 3.49997 600.276 3.49997 600L2.49997 600ZM2.5 3L2.49997 600L3.49997 600L3.5 3L2.5 3Z"
           
              strokeWidth="1px"
              strokeDasharray="5"
              fill="#399fa7"
            />
          </svg>
        </div>
        <Box sx={{ width: "100%" }}>
          <CardOne />
        </Box>
        <Box sx={{ width: "100%" }}>
          <CardTwo />
        </Box>
      </Stack>
    </Container>
  );
};

export default Experience;
